"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var StickyHeader = /*#__PURE__*/function (_HTMLElement) {
  _inherits(StickyHeader, _HTMLElement);
  var _super = _createSuper(StickyHeader);
  function StickyHeader() {
    var _this;
    _classCallCheck(this, StickyHeader);
    _this = _super.call(this);
    _this.header = document.querySelector('.section-header');
    if (!_this.header) return _possibleConstructorReturn(_this);
    _this.header.classList.add('shopify-section-header-sticky');
    _this.announcement = _this.getElementsByClassName('announcement')[0];
    _this.search = _this.getElementsByClassName("header__search")[0];
    _this.searchOpen = _this.getElementsByClassName('header__search')[0];
    _this.searchClose = _this.getElementsByClassName("search-modal__close-button")[0];
    _this.lastHeaderHeight = 0;
    _this.headerBounds = {};
    _this.currentScrollTop = 0;
    _this.onScrollHandler = _this.onScroll.bind(_assertThisInitialized(_this));
    _this.setHeaderHeight = _this.setHeaderHeight.bind(_assertThisInitialized(_this));
    _this.resizeObserver = new ResizeObserver(function () {
      return _this.setHeaderHeight();
    });
    _this.resizeObserver.observe(_this.header);
    // Set immediately to avoid a late first-viewport jump on transparent header pages.
    _this.setHeaderHeight(true);
    window.addEventListener('resize', _this.setHeaderHeight);
    return _this;
  }
  _createClass(StickyHeader, [{
    key: "setHeaderHeight",
    value: function setHeaderHeight() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (!this.header) return;
      var nextHeight = Math.round(this.header.getBoundingClientRect().height);
      if (!force && this.lastHeaderHeight && Math.abs(nextHeight - this.lastHeaderHeight) < 2) return;
      this.lastHeaderHeight = nextHeight;
      document.documentElement.style.setProperty('--header-height', "".concat(nextHeight, "px"));
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      if (!this.header) return;
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
      if (this.searchOpen && this.searchClose) {
        this.searchOpen.addEventListener('click', this.handleSearchOpen.bind(this));
        this.searchClose.addEventListener('click', this.handleSearchClose.bind(this));
      }
      this.handleAnnouncementBarOnLoad();
      this.predictiveSearch = this.querySelector('predictive-search');
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.setHeaderHeight);
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }
  }, {
    key: "createObserver",
    value: function createObserver() {
      var _this2 = this;
      var observer = new IntersectionObserver(function (entries, observer) {
        _this2.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
  }, {
    key: "handleAnnouncementBarOnLoad",
    value: function handleAnnouncementBarOnLoad() {
      if (this.announcement && window.pageYOffset > this.header.offsetHeight) {
        this.announcement.classList.add('small-hide', 'medium-hide', 'large-up-hide');
        this.setHeaderHeight();
      }
    }
  }, {
    key: "onScroll",
    value: function onScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom && !this.search.firstElementChild.getAttribute("open")) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
  }, {
    key: "hide",
    value: function hide() {
      if (this.fullBleed) {
        this.header.classList.remove("shopify-section-header-transparent");
        this.classList.add('header-wrapper--border-bottom');
      }
      if (this.announcement && this.announcement.dataset.hideBar) {
        this.announcement.classList.add('medium-hide', 'large-up-hide');
      }
      if (this.announcement && this.announcement.dataset.hideBarMob) {
        this.announcement.classList.add('small-hide');
      }
      this.header.classList.add('shopify-section-header-sticky');
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.fullBleed) {
        this.header.classList.add("shopify-section-header-transparent", "animate");
        this.classList.remove('header-wrapper--border-bottom');
      }
      if (this.announcement && this.announcement.dataset.hideBar) {
        this.announcement.classList.remove('medium-hide', 'large-up-hide');
      }
      if (this.announcement && this.announcement.dataset.hideBarMob) {
        this.announcement.classList.remove('small-hide');
      }
    }
  }, {
    key: "handleSearchOpen",
    value: function handleSearchOpen(event) {
      if (this.announcement && event.target != this.searchClose) {
        this.announcement.classList.remove("small-hide");
        this.setHeaderHeight();
        var announcementRect = this.announcement.getBoundingClientRect();
        var announcementHeight = announcementRect.bottom > 0 ? announcementRect.height : 0;
        this.style.setProperty('--announcement-height', "".concat(announcementHeight, "px"));
        this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
        document.body.addEventListener('click', this.onBodyClickEvent);
      }
    }
  }, {
    key: "handleSearchClose",
    value: function handleSearchClose() {
      if (this.announcement && this.currentScrollTop >= this.header.offsetHeight) {
        this.announcement.classList.add("small-hide");
      }
      this.style.removeProperty('--announcement-height');
      this.setHeaderHeight();
    }
  }, {
    key: "onBodyClick",
    value: function onBodyClick(event) {
      if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.handleSearchClose(this);
    }
  }]);
  return StickyHeader;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', StickyHeader);
}
var FullBleedHeader = /*#__PURE__*/function (_StickyHeader) {
  _inherits(FullBleedHeader, _StickyHeader);
  var _super2 = _createSuper(FullBleedHeader);
  function FullBleedHeader() {
    var _this3;
    _classCallCheck(this, FullBleedHeader);
    _this3 = _super2.call(this);
    _this3.fullBleed = true;
    if (window.scrollY == 0) _this3.header.classList.add("shopify-section-header-transparent");
    _this3.header.addEventListener('mouseover', _this3.onMouseOver.bind(_assertThisInitialized(_this3)));
    return _this3;
  }
  _createClass(FullBleedHeader, [{
    key: "onMouseOver",
    value: function onMouseOver(event) {
      if (this.header.classList.contains('shopify-section-header-transparent')) {
        this.header.classList.remove("shopify-section-header-transparent");
      }
    }
  }]);
  return FullBleedHeader;
}(StickyHeader);
if (!customElements.get('fullbleed-header')) {
  customElements.define('fullbleed-header', FullBleedHeader);
}